'use client'
import { useRouter as useI18nRouter, usePathname } from 'i18n/routing'
import { useParams, useRouter, useSearchParams } from 'next/navigation'
import { Suspense } from 'react'
import { ControlledSelectInput } from './ControlledSelectInput'

interface Props {
  options: Array<readonly [string, string]>
  param: string
  defaultValue?: string
  className?: string
  title?: string
}

export default function SearchParamSelectInput(props: Props) {
  const router = useRouter()
  return (
    <Suspense
      fallback={
        <ControlledSelectInput
          options={props.options}
          className={props.className}
          value={props.defaultValue ?? ''}
          title={props.title}
          onChange={(value) =>
            router.push(`?${props.param}=${encodeURIComponent(value)}`)
          }
        />
      }
    >
      <InnerSearchParamSelectInput {...props} />
    </Suspense>
  )
}

function InnerSearchParamSelectInput({
  options,
  param,
  className,
  defaultValue,
  title,
}: Props) {
  const searchParams = useSearchParams()
  const router = useI18nRouter()
  const params = useParams<any>()
  const pathname = usePathname()

  return (
    <ControlledSelectInput
      options={options}
      className={className}
      value={searchParams?.get(param) ?? defaultValue ?? ''}
      title={title}
      onChange={(value) => {
        router.push(
          { pathname: pathname, params, query: { [param]: value } },
          {
            scroll: false,
          },
        )
      }}
    />
  )
}
